/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Scene_Description_Job_TitleInputs */

const en_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Shot Description Job`)
};

const fr_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la description du poste`)
};

const de_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung der Aufnahme löschen Job`)
};

const it_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina la descrizione dell'inquadratura Lavoro`)
};

const ru_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить описание кадра. Работа.`)
};

const es_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar descripción de disparo trabajo`)
};

const zh_cn2_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除镜头描述工作`)
};

const ja_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除ショットの説明 仕事`)
};

const hi_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण हटाएं नौकरी`)
};

const pt_pt2_delete_scene_description_job_title = /** @type {(inputs: Delete_Scene_Description_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir descrição do trabalho`)
};

/**
* | output |
* | --- |
* | "Delete Shot Description Job" |
*
* @param {Delete_Scene_Description_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_scene_description_job_title = /** @type {((inputs?: Delete_Scene_Description_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Scene_Description_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_delete_scene_description_job_title(inputs)
	if (locale === "de") return de_delete_scene_description_job_title(inputs)
	if (locale === "it") return it_delete_scene_description_job_title(inputs)
	if (locale === "ru") return ru_delete_scene_description_job_title(inputs)
	if (locale === "es") return es_delete_scene_description_job_title(inputs)
	if (locale === "zh-CN") return zh_cn2_delete_scene_description_job_title(inputs)
	if (locale === "ja") return ja_delete_scene_description_job_title(inputs)
	if (locale === "hi") return hi_delete_scene_description_job_title(inputs)
	if (locale === "pt-PT") return pt_pt2_delete_scene_description_job_title(inputs)
	return en_delete_scene_description_job_title(inputs)
});